<ng-container *ngIf="notification$ | async as notification">
  <fcom-notification
    [ngClass]="{ 'pr-small-b': !isFullWidth, 'data-full-width': isFullWidth }"
    [theme]="theme"
    [layout]="isFullWidth ? NotificationLayout.EDGE_TO_EDGE : NotificationLayout.BLOCK"
    [linkText]="'readMore' | finLocalization"
    [linkUrl]="notification.article.url"
    (linkClick)="showModal($event)"
  >
    {{ notification.article.teaserTitle }}
  </fcom-notification>

  <fcom-modal [(open)]="modalOpen" [title]="'modal.moreInfoTitle' | finLocalization">
    <cms-unstyled-fragment
      class="block pr-medium"
      [cmsContent$]="notification$ | finMap: 'article'"
      [showTitle]="false"
    ></cms-unstyled-fragment>
  </fcom-modal>
</ng-container>
